import { AddNewButtonShell } from '@/components/RootScreenButtons/buildingBlocks/AddNewButtonShell';
import { useAppPush } from '@/hooks/useAppPush';
import useTranslation from '@/hooks/useTranslation';

export const GoToOptionsButton = () => {
  const t = useTranslation();
  const { push } = useAppPush();
  return (
    <AddNewButtonShell
      onClick={() => {
        push('/options');
      }}
      hideAddIcon
    >
      {t('section.OPTIONS')}
    </AddNewButtonShell>
  );
};
